<p-card header="Group Totals" *ngIf="showGroupTotals">
  <form [formGroup]="groupForm">
    <div class="p-grid">
      <div class="p-col form-group">
        <label>Primary Pieces</label>
        <input type="text" pInputText formControlName="groupPrimaryPieces" class="boldNumber" lib-numeric (change)="save()" />
      </div>
      <div class="p-col form-group" *ngIf="showSecondaryPieces">
        <label>Secondary Pieces</label>
        <input type="text" pInputText formControlName="groupSecondaryPieces" class="boldNumber" lib-numeric (change)="save()" />
      </div>
      <div class="p-col form-group" *ngIf="showQuality">
        <label>Audited</label>
        <input type="text" pInputText formControlName="groupAudited" class="boldNumber" lib-numeric (change)="save()" />
      </div>
      <div class="p-col form-group" *ngIf="showQuality">
        <label>Failed</label>
        <input type="text" pInputText formControlName="groupFailed" class="boldNumber" lib-numeric (change)="save()" />
      </div>

      <div class="p-col form-group" *ngIf="showQuality">
        <label>Quality</label>
        <input type="text" pInputText disabled class="boldNumber" [value]="groupQuality" />
      </div>
      <div class="p-col form-group" *ngIf="showQuality">
        <label>Allowed Bad</label>
        <input type="text" pInputText disabled class="boldNumber" [value]="groupAllowedBad" />
      </div>

      <div class="p-col form-group" *ngIf="showQuality">
        <label>After Penalty</label>
        <input type="text" pInputText disabled class="boldNumber" [value]="groupAfterPenalty" />
      </div>
    </div>
  </form>
</p-card>


